// ENG-1830: Hard-coded per-manager visible technician lists for Fox & Sons.
// Keys are manager login emails; values are the ServiceTitan technician IDs
// (crm_external_id) of the techs that manager is allowed to see.
// If a user's email is not a key here, they see all technicians as normal.
const FOX_SONS_MANAGER_TECH_IDS = {
  // Plumbing team — Paul Leibel
  "paul_l@foxandsons.ca": [
    204856505, // Clinton Allen
    207517801, // Cameron Dick
    109850334, // Jayden Dale
    111888643, // Matthew Nolan
    111874482, // Paramjit Bhullar
    34850456, // Tristan Schlase
    239450745, // Cole Cook
    67943632, // Craig Viggars
    303203, // Michael Illingby (team lead)
    26064396, // Paul Leibel (self)
  ],
  // Electrical team — Scott Cahill
  "scott@foxandsons.ca": [
    203690604, // Denis Richards
    56502991, // Jason Sargent
    87798606, // Kevin Costanzo
    100980306, // Melvin Galbraith
    63801424, // Dale Cooper
    11008380, // Scott Cahill (self / team lead)
  ],
  // Piecework team — Luke Cruickshank
  "luke_c@foxandsons.ca": [
    56510289, // Dylan Murphy
    116024448, // Oleksiy Krolivets
    101252306, // Ross Birdsall
    11313825, // Luke Cruickshank (self)
  ],
  // Service / HVAC team — Aaron Chan
  "aaron_c@foxandsons.ca": [
    116961529, // Adam Houston
    201350967, // Carlo Myles
    37715670, // Darcy Plouffe
    67951970, // Alonso Oyarzun
    115296555, // Adam Funk
    142219485, // Cody Mackenzie
    206035289, // Inderpal Singh
    205299936, // Jonathan Apa
    141566678, // Tyler Nedeljak
    271971, // Justin Hall
    66639202, // Sami Kerton (service team lead)
    114262908, // Aaron Chan (self)
  ],
} as const;

type FoxSonsManagerEmail = keyof typeof FOX_SONS_MANAGER_TECH_IDS;

export const FOX_SONS_BUSINESS_NAME = "Fox and Sons";

// Returns the set of allowed ST tech IDs for the given email, or null if the
// email is not in the map (meaning no filtering should be applied).
export const getFoxSonsVisibleTechIds = (email: string): Set<string> | null => {
  const normalizedEmail = email.toLowerCase();
  if (normalizedEmail in FOX_SONS_MANAGER_TECH_IDS) {
    return new Set(
      FOX_SONS_MANAGER_TECH_IDS[normalizedEmail as FoxSonsManagerEmail].map(
        String,
      ),
    );
  }
  return null;
};
